import { render, staticRenderFns } from "./numericSimple.vue?vue&type=template&id=04c0c1a0&"
import script from "./numericSimple.vue?vue&type=script&lang=js&"
export * from "./numericSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QField,QInput})
